/**
 * @file 非VueX的store，哪里都能用，存储少量数据
 * @note 单向
 */
const store = new Map()

export const setStore = (key: string, value: unknown) => {
  console.groupCollapsed(`[Standard Store: ${key}]`)
  console.log(value)
  console.groupEnd()
  store.set(key, value)
}

export const getStore = (key: string) => store.get(key)

export const deleteStore = (key: string) =>
  store.delete(key)
